var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    id: "svg",
    viewBox: "0 0 1440 700",
    xmlns: "http://www.w3.org/2000/svg",
    className: "transition duration-300 ease-in-out delay-150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0,700 C 0,700 0,350 0,350 C 208.40000000000003,405.4666666666667 416.80000000000007,460.93333333333334 555,449 C 693.1999999999999,437.06666666666666 761.2,357.73333333333335 897,330 C 1032.8,302.26666666666665 1236.4,326.1333333333333 1440,350 C 1440,350 1440,700 1440,700 Z",
    stroke: "none",
    strokeWidth: 0,
    fill: "#f9fcf4",
    className: "transition-all duration-300 ease-in-out delay-150 path-0",
    transform: "rotate(-180 720 350)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.9d6c3e2948aa879c5fe6951b8de05248.svg";
export { ForwardRef as ReactComponent };